export default __webpack_public_path__ + "static/media/882.f33b9f69.gif";